import { DefaultListButtonOptions } from './default-list-button-options';
export class DefaultListButtonsOptions {
    constructor(){
    }

    ShowDefaultListButtons: boolean = true;
    Add: DefaultListButtonOptions;
    DeleteAll: DefaultListButtonOptions;
    Print: DefaultListButtonOptions;
    PrintSelected: DefaultListButtonOptions;

    Load(data: any): DefaultListButtonsOptions {
        if(data){
            this.ShowDefaultListButtons = data.showDefaultListButtons != null ? data.showDefaultListButtons : true;
            this.Add = new DefaultListButtonOptions().Load(data.add);
            this.DeleteAll = new DefaultListButtonOptions().Load(data.deleteAll);
            this.Print = new DefaultListButtonOptions().Load(data.print);
            this.PrintSelected = new DefaultListButtonOptions().Load(data.printSelected);
        }
        return this;
    }
}